/**
 * The Manager+ role tier, shared by every surface that gates on it.
 *
 * This is a LEAF module: it imports only the generated `RoleName` enum, so a
 * consumer can read the role set without dragging the `@/features/auth`
 * barrel (and `expo-device` behind it) into its module graph. That constraint
 * is why `features/player-kanban/constants/pipelineTierRoles` originally
 * declared its own copy; it now re-exports this one so the two can never
 * drift.
 *
 * Drift here is not cosmetic. Two copies of "who is a Manager" is two
 * answers to one authorization question, and the surface reading the stale
 * copy is the one that leaks. SE-6936 is the worked example: Squad had no
 * role set at all and gated on a PostHog flag instead, which let a MEMBER
 * reach the Squad nav item, the `/squad` route and the Home Squad widget.
 * @module constants/managerPlusRoles
 */

import { RoleName } from "@/generated/graphql";

/**
 * Organization roles that clear a Manager+ gate.
 *
 * Everything not in this set — notably `RoleName.Member` — is denied.
 */
export const MANAGER_PLUS_ROLES: ReadonlySet<RoleName> = new Set([
  RoleName.Owner,
  RoleName.Admin,
  RoleName.Manager,
]);
